import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';

export default function TextBoxControl(props) {

    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    function onChange(value) {
        if (props.onlyNumbers) {
            value = value.replace(/[^0-9]/g, '');
        }

        setValue(value);

        if (props.onChange)
            props.onChange(value);
    }



    function setNewValue(value) {
        setValue(value);
    }

    function onBlur(value) {
        setValue(value);
        if (props.onBlur)
            props.onBlur(value)
    }

    return (
        <div>
            <Form.Group className="mb-3">
                {props.title != null &&
                    <Form.Label>{props.title}<span className="text-danger fw-bold"> {props.required && '*'}</span> </Form.Label>
                }
                <Form.Control
                    type={props.type ? props.type : 'text'}
                    ref={props.inputRef}
                    autoComplete={!props.hideAutoComplete}
                    value={value}
                    required={props.required}
                    valid={props.valid}
                    tabIndex={props.tabindex}
                    className={props.className}
                    maxLength={props.maxlength ? props.maxlength : '-1'}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={(e) => onBlur(e.target.value)}
                    placeholder={props.placeholder}
                    disabled={props.disabled ? true : false}
                />
            </Form.Group>
        </div>
    )
}